import ShopApiClient from './ShopApiClient';

class BerrySupportScriptTagApi extends ShopApiClient {
  constructor() {
    super('script', { accountScoped: false, apiVersion: 'v1' });
  }
}

export default new BerrySupportScriptTagApi();
